// extracted by mini-css-extract-plugin
var _1 = "N8JgursxU3gg9d14GD5k";
export { _1 as "input-number-align-right" }
